'use strict';

var id           = 'pageScanning',
    Page         = require('stb-component-page'),
    app          = require('mag-app'),
    LayoutList   = require('mag-component-layout-list'),
    ModalMessage = require('mag-component-modal'),
    Progress     = require('spa-component-progress-bar'),
    keys         = require('stb-keys'),
    Footer       = require('mag-component-footer'),

    page         = new Page({
        $node: document.getElementById(id),
        className: 'theme-page-background'
    }),

    $frequency = document.getElementById('scanningFrequency'),
    findCount = 0,
    $count = document.getElementById('scanningCount'),
    $channel = document.getElementById('scanningChannel'),
    scanning = false;


function stopScanning () {
    app.provider.stopScan();
    app.route(app.pages.scanOptions);
}


function onProgress ( info ) {
    page.progress.set(info.progress);
    page.progress.$percents.innerText = info.progress + '%';
    $frequency.innerText = info.frequency;
}


function onFound ( info ) {
    findCount++;
    $count.innerText = findCount;
    $channel.innerText = info.name;
}


function onEnd () {
    page.progress.set(100);
    page.progress.$percents.innerText = '100%';
    scanning = false;
    app.route(app.pages.main);
}


document.getElementById('scanningFrequencyTitle').innerText = gettext('Frequency');
document.getElementById('scanningCountTitle').innerText = gettext('Found in total');
document.getElementById('scanningChannelTitle').innerText = gettext('Last found');
document.getElementById('scanningTitle').innerText = gettext('Finding DVB channels');


page.footer = new Footer({
    visible: true,
    parent: page,
    data: [
        {
            code: keys.f1,
            title: gettext('Stop scanning'),
            action: stopScanning
        },
        {
            code: keys.menu,
            action: function () {
                page.modalActions.show();
            }
        }
    ]
});


page.progress = new Progress({
    $node: document.getElementById('scanningProgress'),
    value: 0,
    className: 'theme-progressbar'
});
page.progress.$percents = document.getElementById('scanningProgressValue');


page.modalActions = new ModalMessage({
    visible: false,
    title: gettext('actions'),
    events: {
        show: function () {
            this.focus();
        }
    },
    children: [
        new LayoutList({
            cycle: true,
            size: 1,
            focusIndex: 0,
            data: [
                {
                    items: [
                        {className: 'theme-icon theme-icon-rc-f1', value: ''},
                        {value: gettext('Stop scanning')}
                    ],
                    click: function () {
                        stopScanning();
                        page.modalActions.hide();
                    }
                }
            ],
            events: {
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    if ( event.code === keys.back || event.code === keys.menu ) {
                        event.stop = true;
                        page.modalActions.hide();
                    }
                }
            }
        })
    ]
});
page.add(page.modalActions);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            event.stop = true;
            if ( scanning ) {
                core.notify({
                    // grammar mistake: wont -> want. Fix grammar with
                    title: gettext('Do you want to stop scanning?'),
                    // translation keys in po files
                    icon: 'info',
                    type: '',
                    buttons: [
                        {
                            value: gettext('Cancel'),
                            click: function () { /* do nothing*/ }
                        },
                        {
                            value: gettext('Stop'),
                            click: stopScanning
                        }
                    ]
                });
            } else {
                app.route(app.pages.scanOptions);
            }
            break;
    }
});


page.addListener('show', function ( data ) {
    var config = data.data;

    page.config = {
        type: config.currentType.type,
        callbacks: {
            onProgress: onProgress,
            onFound: onFound,
            onEnd: onEnd
        }
    };
    scanning = true;
    if ( app.lastIntent ) {
        app.lastIntent.emit('playback:stop');
    }
    findCount = 0;
    $count.innerText = '0';
    $channel.innerText = '';
    $frequency.innerText = '';
    if ( config.manual ) {
        if ( config.more ) {
            page.config.netId = config.network;
            page.config.frequency = config.frequency;
            page.config.modulation = config.modulation;
            page.config.symRate = config.symbolRate;
        } else {
            page.config.frequency = config.frequencyStart;
            page.config.frequencyEnd = config.frequencyEnd;
            page.config.band = config.band;
        }
        app.provider.startManualScan(page.config);
    } else {
        if ( config.more ) {
            page.config.symRate = config.symbolRate;
            page.config.modulation = config.modulation;
        }
        app.provider.startAutoScan(page.config);
    }
});


// public
module.exports = page;
